import _ from 'lodash';
import type { VideoMetadataItem } from '@/modules/shared';
import type { Genre } from '@/modules/shared/types/video.type';

export function isVideoMetadataGenresField(field: unknown): field is VideoMetadataItem & { value: Genre[] } {
  return _.isObject(field)
    && 'fieldName' in field && 'displayName' in field && 'value' in field && 'type' in field
    && field.fieldName === 'genres'
    && (Array.isArray(field.value));
}
